/* unplugin-vue-components disabled */import script from "./voice.vue?vue&type=script&lang=ts&setup=true"
export * from "./voice.vue?vue&type=script&lang=ts&setup=true"

import "./voice.vue?vue&type=style&index=0&id=173d6bd2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-173d6bd2"]])

export default __exports__